import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  AppointmentsTableHeader,
  TableActionsPlaceholder,
} from "../TreatmentAppointment/TreatmentAppointment.styled";

interface TreatmentAppointmentsTableHeaderProps {
  showActionsColumn?: boolean;
}

const TreatmentAppointmentsTableHeader: React.FC<
  TreatmentAppointmentsTableHeaderProps
> = ({ showActionsColumn = true }) => {
  const { t } = useTranslation();

  return (
    <AppointmentsTableHeader showActionsColumn={showActionsColumn}>
      <Box sx={{ marginLeft: "-6px" }}>{t("treatmentPlan.apptStepName")}</Box>
      <Box>{t("treatmentPlan.cdtCode")}</Box>
      <Box>{t("treatmentPlan.tooth")}</Box>
      <Box>{t("treatmentPlan.surface")}</Box>
      <Box>{t("treatmentPlan.fee")}</Box>
      {showActionsColumn && <TableActionsPlaceholder />}
    </AppointmentsTableHeader>
  );
};

export default TreatmentAppointmentsTableHeader;
